// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout-module--layout--3Pyz6","layout--full":"Layout-module--layout--full--pf2mb","layout--legacy":"Layout-module--layout--legacy--1muer"};